(() => {
  let lockedScrollY = 0;
  const root = document.documentElement;

  window.ushoreLockPage = () => {
    if (document.body.classList.contains('ushore-scroll-locked')) return;
    lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('ushore-scroll-locked');
    document.body.classList.add('ushore-scroll-locked', 'overflow-hidden');
  };

  window.ushoreUnlockPage = () => {
    if (document.querySelector('ushore-search-drawer.active, ushore-wishlist-drawer.active, ushore-menu-drawer.active, cart-drawer.active')) return;
    if (!document.body.classList.contains('ushore-scroll-locked')) return;
    document.documentElement.classList.remove('ushore-scroll-locked');
    document.body.classList.remove('ushore-scroll-locked', 'overflow-hidden');
    window.scrollTo(0, lockedScrollY);
  };

  window.ushoreCloseUtilityDrawers = (except) => {
    document.querySelectorAll('ushore-search-drawer.active, ushore-wishlist-drawer.active, ushore-menu-drawer.active, cart-drawer.active').forEach((drawer) => {
      if (drawer === except) return;
      if (typeof drawer.close === 'function') {
        drawer.close();
        return;
      }
      window.ushoreCloseDrawerWithMotion?.(drawer);
    });
    window.ushoreUnlockPage?.();
  };

  const hasOpenScrollLockSurface = () =>
    Boolean(
      document.querySelector(
        [
          'cart-drawer.active',
          'ushore-search-drawer.active',
          'ushore-wishlist-drawer.active',
          'ushore-menu-drawer.active',
          'details[open].menu-opening',
          'modal-dialog[open]',
          'pickup-availability-drawer[open]',
        ].join(', ')
      )
    );

  const clearStaleScrollLocks = () => {
    if (hasOpenScrollLockSurface()) return;
    document.documentElement.classList.remove('ushore-scroll-locked');
    document.body.classList.remove(
      'ushore-scroll-locked',
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );
  };

  window.ushoreClearStaleScrollLocks = clearStaleScrollLocks;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearStaleScrollLocks, { once: true });
  } else {
    clearStaleScrollLocks();
  }
  window.addEventListener('pageshow', clearStaleScrollLocks);
  window.addEventListener('resize', () => window.requestAnimationFrame(clearStaleScrollLocks));
  window.visualViewport?.addEventListener('resize', () => window.requestAnimationFrame(clearStaleScrollLocks));

  const keepDrawerAtViewportRoot = (drawer) => {
    if (!drawer || drawer.parentElement === document.body) return;
    document.body.insertBefore(drawer, document.body.firstElementChild);
  };
  window.ushoreKeepDrawerAtViewportRoot = keepDrawerAtViewportRoot;

  const clearPageShellTransform = () => {
    document.body.style.transform = 'none';
  };
  window.ushoreClearPageShellTransform = clearPageShellTransform;

  document.querySelectorAll('cart-drawer, ushore-search-drawer, ushore-wishlist-drawer').forEach(keepDrawerAtViewportRoot);

  window.ushoreCloseDrawerWithMotion = (drawer, afterClose) => {
    if (!drawer || drawer.classList.contains('ushore-drawer-closing')) return;
    drawer.classList.add('ushore-drawer-closing');
    drawer.classList.remove('active');
    window.setTimeout(() => {
      drawer.classList.remove('animate', 'ushore-drawer-closing');
      drawer.setAttribute('aria-hidden', 'true');
      afterClose?.();
    }, 620);
  };

  const header = document.querySelector('.shopify-section-group-header-group');
  const getHeaderSurfaces = () => [
    document.querySelector('.shopify-section-group-header-group .header.page-width'),
    document.querySelector('.shopify-section-group-header-group .header'),
    document.querySelector('.shopify-section-group-header-group .header-wrapper'),
    document.querySelector('.shopify-section-group-header-group sticky-header'),
    header,
  ].filter((element, index, elements) => element && elements.indexOf(element) === index);
  const clampHeaderHeight = (height) => {
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    const minHeight = isDesktop ? 56 : 52;
    const maxHeight = isDesktop ? 88 : 78;
    return Math.min(Math.max(Math.round(height || 0), minHeight), maxHeight);
  };
  const getHeaderHeight = () => {
    const measuredHeight = getHeaderSurfaces().reduce((height, element) => {
      const rect = element.getBoundingClientRect();
      const styles = window.getComputedStyle(element);
      return Math.max(
        height,
        rect.height || 0,
        element.offsetHeight || 0,
        parseFloat(styles.height) || 0,
        parseFloat(styles.minHeight) || 0
      );
    }, 0);
    const fallbackHeight = parseFloat(window.getComputedStyle(root).getPropertyValue('--ushore-header-height')) || 0;
    return clampHeaderHeight(Math.max(measuredHeight, fallbackHeight));
  };
  const backToTop = document.querySelector('.ushore-back-to-top');
  const isHomePage = document.body.classList.contains('template-index');
  let lastScrollY = window.scrollY;
  let ticking = false;
  let headerHidden = false;
  let cachedHeaderHeight = 0;

  const setHeaderHeight = () => {
    cachedHeaderHeight = getHeaderHeight();
    if (!cachedHeaderHeight) return;
    root.style.setProperty('--ushore-header-height', `${cachedHeaderHeight}px`);
  };

  const updateChrome = () => {
    const currentY = window.scrollY;
    const headerHeight = cachedHeaderHeight || getHeaderHeight();
    const homeHeroSection = isHomePage
      ? document.querySelector('#MainContent > .shopify-section:first-child .ushore-hero')?.closest('.shopify-section')
      : null;
    const nextSection = homeHeroSection?.nextElementSibling;
    const isScrolled = isHomePage
      ? nextSection
        ? nextSection.getBoundingClientRect().top <= headerHeight + 1
        : currentY > 24
      : true;
    headerHidden = false;
    root.classList.toggle('ushore-is-scrolled', isScrolled);
    root.classList.toggle('ushore-header-hidden', headerHidden);
    if (header) {
      header.classList.toggle('ushore-header-scrolled', isScrolled);
      header.classList.toggle('ushore-header-hidden', headerHidden);
    }
    if (backToTop) backToTop.classList.toggle('is-visible', window.scrollY > 700);
    lastScrollY = currentY;
    ticking = false;
  };

  const scrollbarMedia = window.matchMedia('(min-width: 750px)');
  const scrollbar = document.createElement('div');
  const scrollbarThumb = document.createElement('div');
  scrollbar.className = 'ushore-scrollbar';
  scrollbarThumb.className = 'ushore-scrollbar__thumb';
  scrollbar.appendChild(scrollbarThumb);
  if (scrollbarMedia.matches) document.body.appendChild(scrollbar);

  const updateScrollbar = () => {
    if (!scrollbarMedia.matches) return;
    if (!scrollbar.isConnected) document.body.appendChild(scrollbar);
    const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, window.scrollY / maxScroll));
    const thumbHeight = Math.max(54, Math.round((window.innerHeight / document.documentElement.scrollHeight) * window.innerHeight));
    const travel = Math.max(0, window.innerHeight - thumbHeight);
    scrollbarThumb.style.height = `${thumbHeight}px`;
    scrollbarThumb.style.transform = `translate3d(0, ${Math.round(travel * progress)}px, 0)`;
  };
  const syncScrollbarMount = () => {
    if (scrollbarMedia.matches) {
      updateScrollbar();
    } else if (scrollbar.isConnected) {
      scrollbar.remove();
    }
  };

  setHeaderHeight();
  clearPageShellTransform();
  updateChrome();
  root.classList.add('ushore-page-ready');

  window.addEventListener('pageshow', () => {
    root.classList.remove('ushore-page-leaving');
    root.classList.add('ushore-page-ready');
    clearPageShellTransform();
    setHeaderHeight();
    updateChrome();
    updateScrollbar();
  });

  window.addEventListener('pagehide', () => {
    root.classList.add('ushore-page-leaving');
  });

  window.addEventListener('resize', () => {
    setHeaderHeight();
    updateChrome();
    syncScrollbarMount();
  });
  scrollbarMedia.addEventListener?.('change', syncScrollbarMount);
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      updateChrome();
      updateScrollbar();
    });
  }, { passive: true });
  updateScrollbar();

  document.addEventListener('pointerdown', (event) => {
    const target = event.target.closest('a, button, summary, .card-wrapper, .product-card-wrapper');
    if (!target) return;
    target.classList.add('ushore-pressing');
  }, { passive: true });

  ['pointerup', 'pointercancel', 'mouseleave'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      document.querySelectorAll('.ushore-pressing').forEach((target) => {
        if (eventName === 'mouseleave' && target.contains(event.target)) return;
        target.classList.remove('ushore-pressing');
      });
    }, { passive: true });
  });

  const prefetchedUrls = new Set();
  const shouldPrefetchLink = (anchor) => {
    if (!anchor?.href || anchor.target || anchor.hasAttribute('download')) return false;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return false;
    if (/\.(?:jpg|jpeg|png|gif|webp|avif|svg|pdf|zip|mp4|mov)$/i.test(url.pathname)) return false;
    if (/\/(?:cart|checkout|account|search)(?:\/|$)/.test(url.pathname)) return false;
    return true;
  };

  const prefetchLink = (anchor) => {
    if (!shouldPrefetchLink(anchor)) return;
    const url = new URL(anchor.href, window.location.href);
    url.hash = '';
    const href = url.toString();
    if (prefetchedUrls.has(href)) return;
    prefetchedUrls.add(href);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  };

  ['pointerenter', 'touchstart'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const anchor = event.target.closest('a[href]');
      if (anchor) prefetchLink(anchor);
    }, { capture: true, passive: true });
  });

  if (backToTop) {
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  document.addEventListener(
    'click',
    (event) => {
      const accordionTrigger = event.target.closest('.ushore-product-description__accordion-trigger');
      if (accordionTrigger) {
        const accordion = accordionTrigger.closest('[data-ushore-product-accordion]');
        const contentId = accordionTrigger.getAttribute('aria-controls');
        const content = contentId ? document.getElementById(contentId) : null;
        if (!accordion || !content) return;

        const isOpen = accordion.dataset.open === 'true';
        if (isOpen) {
          accordion.dataset.open = 'false';
          accordionTrigger.setAttribute('aria-expanded', 'false');
          content.hidden = false;
          content.style.maxHeight = `${content.scrollHeight}px`;
          content.style.opacity = '1';
          window.requestAnimationFrame(() => {
            content.style.maxHeight = '0px';
            content.style.opacity = '0';
          });
          window.setTimeout(() => {
            if (accordion.dataset.open !== 'true') {
              content.hidden = true;
            }
          }, 240);
        } else {
          accordion.dataset.open = 'true';
          accordionTrigger.setAttribute('aria-expanded', 'true');
          content.hidden = false;
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          window.requestAnimationFrame(() => {
            content.style.maxHeight = `${content.scrollHeight}px`;
            content.style.opacity = '1';
          });
        }

        return;
      }

      const button = event.target.closest(
        'media-gallery > .slider-mobile-gutter:not(.thumbnail-slider) .slider-button'
      );
      if (!button) return;

      const gallery = button.closest('media-gallery');
      if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

      const items = Array.from(gallery.querySelectorAll('[id^="Slider-Gallery"] .product__media-item[data-media-id]'));
      if (items.length < 2) return;

      event.preventDefault();
      event.stopPropagation();

      const activeItem = gallery.querySelector('[id^="Slider-Gallery"] .product__media-item.is-active') || items[0];
      const activeIndex = Math.max(items.indexOf(activeItem), 0);
      const direction = button.classList.contains('slider-button--prev') ? -1 : 1;
      const nextIndex = (activeIndex + direction + items.length) % items.length;
      const nextMediaId = items[nextIndex].dataset.mediaId;

      gallery.setActiveMedia(nextMediaId, false);

      const activeThumbnail = gallery.querySelector(`[data-target="${nextMediaId}"]`);
      if (activeThumbnail) {
        activeThumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ushore-size-guide[open]').forEach((guide) => guide.removeAttribute('open'));
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.ushore-size-guide[open]').forEach((guide) => {
      if (!guide.contains(event.target)) guide.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-ushore-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('.ushore-lookbook__slide'));
    if (slides.length < 2) return;
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    const show = (nextIndex) => {
      slides[index].classList.remove('is-active');
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    };

    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => show(index - 1));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(index + 1));

    if (carousel.hasAttribute('data-ushore-autoplay')) {
      window.setInterval(() => show(index + 1), 4800);
    }
  });

  document.querySelectorAll('[data-ushore-announcement-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const bar = button.closest('[data-ushore-announcement]');
      if (bar) bar.hidden = true;
    });
  });

  document.querySelectorAll('.product__media img').forEach((image) => {
    if (window.matchMedia('(max-width: 749px)').matches) return;

    image.addEventListener('mousemove', (event) => {
      const rect = image.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      image.style.setProperty('--zoom-x', `${x}%`);
      image.style.setProperty('--zoom-y', `${y}%`);
    });
    image.addEventListener('mouseleave', () => {
      image.style.removeProperty('--zoom-x');
      image.style.removeProperty('--zoom-y');
    });
  });

  const syncVariantPills = (scope = document) => {
    scope.querySelectorAll('.product-form__input--pill, .product-form__input--size').forEach((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      fieldset.querySelectorAll('label.is-selected').forEach((label) => label.classList.remove('is-selected'));
      if (!checked) return;
      const escapedId = window.CSS?.escape ? CSS.escape(checked.id) : checked.id.replace(/"/g, '\\"');
      const label = fieldset.querySelector(`label[for="${escapedId}"]`);
      label?.classList.add('is-selected');
      const selectedValue = fieldset.querySelector('[data-selected-value]');
      if (selectedValue) selectedValue.textContent = checked.value;
    });
  };

  syncVariantPills();
  document.addEventListener('change', (event) => {
    if (!event.target.matches('.product-form__input--pill input[type="radio"], .product-form__input--size input[type="radio"]')) return;
    syncVariantPills(event.target.closest('variant-selects') || document);
  });
  document.addEventListener('shopify:section:load', (event) => syncVariantPills(event.target));

})();

(() => {
  const drawer = document.querySelector('ushore-menu-drawer');
  const openButton = document.querySelector('[data-ushore-menu-open]');
  if (!drawer || !openButton) return;
  window.ushoreKeepDrawerAtViewportRoot?.(drawer);

  const close = () => {
    window.ushoreCloseDrawerWithMotion(drawer, () => {
      openButton.setAttribute('aria-expanded', 'false');
      window.ushoreUnlockPage?.();
      openButton.focus({ preventScroll: true });
    });
  };

  const open = () => {
    if (drawer.classList.contains('active')) return;
    window.ushoreCloseUtilityDrawers?.(drawer);
    drawer.classList.remove('ushore-drawer-closing');
    drawer.classList.add('animate');
    window.requestAnimationFrame(() => {
      drawer.classList.add('active');
    });
    drawer.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');
    window.ushoreLockPage?.();
    drawer.querySelector('.drawer__inner')?.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ushore-menu-open]')) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest('ushore-menu-drawer [data-ushore-menu-close]')) close();
  });

  drawer.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') close();
  });
})();

(() => {
  const drawer = document.querySelector('ushore-search-drawer');
  if (!drawer) return;
  window.ushoreKeepDrawerAtViewportRoot?.(drawer);

  const input = drawer.querySelector('[data-ushore-search-input]');
  const form = drawer.querySelector('[data-ushore-search-form]');
  const results = drawer.querySelector('[data-ushore-search-results]');
  let timer;
  let controller;
  const cache = new Map();

  const escapeHTML = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);

  const close = () => {
    window.ushoreCloseDrawerWithMotion(drawer, () => window.ushoreUnlockPage?.());
  };

  const open = () => {
    if (drawer.classList.contains('active')) return;
    window.ushoreCloseUtilityDrawers?.(drawer);
    drawer.classList.remove('ushore-drawer-closing');
    drawer.classList.add('animate');
    window.requestAnimationFrame(() => {
      drawer.classList.add('active');
    });
    drawer.setAttribute('aria-hidden', 'false');
    window.ushoreLockPage?.();
    window.setTimeout(() => input?.focus({ preventScroll: true }), 40);
  };

  const renderGroup = (_title, items, type) => {
    if (!items?.length) return '';
    const cards = items.map((item) => {
      const image = item.image || item.featured_image;
      const imageUrl = typeof image === 'string' ? image : image?.url || image?.src;
      return `
        <a class="ushore-search-result ushore-search-result--${escapeHTML(type || 'item').toLowerCase()}" href="${escapeHTML(item.url)}">
          ${imageUrl ? `<img src="${escapeHTML(imageUrl)}" alt="${escapeHTML(item.title)}" loading="lazy">` : '<span class="ushore-search-result__placeholder"></span>'}
          <strong>${escapeHTML(item.title)}</strong>
        </a>
      `;
    }).join('');
    return `<section class="ushore-search-group">${cards}</section>`;
  };

  const search = async (term) => {
    const query = term.trim();
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }

    if (cache.has(query)) {
      results.innerHTML = cache.get(query);
      return;
    }

    if (controller) controller.abort();
    controller = new AbortController();

    try {
      const response = await fetch(
        `${window.routes.predictive_search_url}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`,
        { signal: controller.signal }
      );
      const data = await response.json();
      const resources = data.resources?.results || {};
      const products = resources.products || [];
      const markup = renderGroup('Products', products, 'Product');

      const nextMarkup = markup || '<p class="ushore-side-drawer__empty">No results found.</p>';
      cache.set(query, nextMarkup);
      results.innerHTML = nextMarkup;
    } catch (error) {
      if (error.name === 'AbortError') return;
      results.innerHTML = '<p class="ushore-side-drawer__empty">Search is unavailable right now.</p>';
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ushore-search-open]')) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest('ushore-search-drawer [data-ushore-drawer-close]')) close();
  });

  drawer.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') close();
  });

  input?.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => search(input.value), 35);
  });

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    search(input.value);
  });
})();

(() => {
  const key = 'ushore:wishlist';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; }
  };
  const write = (items) => localStorage.setItem(key, JSON.stringify(items));
  const normalizeUrl = (url) => {
    try {
      const parsed = new URL(url || '', window.location.origin);
      const productMatch = parsed.pathname.match(/\/products\/[^/?#]+/);
      if (productMatch) return `${productMatch[0]}${parsed.search}`;
      return `${parsed.pathname}${parsed.search}`;
    } catch {
      return String(url || '').split('#')[0];
    }
  };
  const itemUrl = (item) => normalizeUrl(typeof item === 'string' ? item : item.url);
  const itemTitle = (item) => typeof item === 'string' ? 'Saved item' : item.title;
  const formatPrice = (price) => {
    if (price === null || price === undefined || price === '') return '';
    const cents = Number(price || 0);
    if (Number.isNaN(cents)) return '';
    return `RS. ${(cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };
  const escapeHTML = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);
  const drawer = document.querySelector('ushore-wishlist-drawer');
  window.ushoreKeepDrawerAtViewportRoot?.(drawer);
  const drawerItems = drawer?.querySelector('[data-wishlist-drawer-items]');
  let renderToken = 0;
  const enrichItems = async (items) => {
    const enriched = await Promise.all(items.map(async (item) => {
      if (typeof item !== 'string' && item.image && item.title && item.variantId && item.price) return item;
      const url = itemUrl(item);
      try {
        const response = await fetch(`${url.split('?')[0]}.js`);
        if (!response.ok) return item;
        const product = await response.json();
        return {
          url,
          title: product.title || itemTitle(item),
          image: product.featured_image || '',
          variantId: product.variants?.[0]?.id || '',
          price: product.price || product.variants?.[0]?.price || '',
        };
      } catch {
        return item;
      }
    }));
    if (JSON.stringify(enriched) !== JSON.stringify(items)) write(enriched);
    return enriched;
  };
  const closeDrawer = () => {
    if (!drawer) return;
    window.ushoreCloseDrawerWithMotion(drawer, () => window.ushoreUnlockPage?.());
  };
  const renderDrawer = async () => {
    if (!drawerItems) return;
    const token = ++renderToken;
    const items = await enrichItems(read());
    if (token !== renderToken) return;
    if (items.length === 0) {
      drawerItems.innerHTML = '<p class="ushore-side-drawer__empty">You have not added any items to your wishlist.</p>';
      return;
    }
    drawerItems.innerHTML = items
      .map((item) => {
        const url = itemUrl(item);
        const title = itemTitle(item);
        const image = typeof item === 'string' ? '' : item.image;
        const variantId = typeof item === 'string' ? '' : item.variantId;
        const price = typeof item === 'string' ? '' : formatPrice(item.price);
        return `
          <article class="ushore-wishlist-drawer__item">
            <a class="ushore-wishlist-drawer__link" href="${escapeHTML(url)}">
              <span class="ushore-wishlist-drawer__media">
                ${image ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(title)}" loading="lazy">` : '<span class="ushore-wishlist-drawer__placeholder"></span>'}
              </span>
              <span class="ushore-wishlist-drawer__meta">
                <strong>${escapeHTML(title)}</strong>
                ${price ? `<small>${escapeHTML(price)}</small>` : ''}
              </span>
            </a>
            <div class="ushore-wishlist-drawer__actions">
              <button type="button" data-wishlist-add data-variant-id="${escapeHTML(variantId)}"${variantId ? '' : ' disabled'} aria-label="Add ${escapeHTML(title)} to cart">
                <span aria-hidden="true">Add</span>
              </button>
              <button type="button" data-wishlist-remove data-url="${escapeHTML(url)}" aria-label="Remove ${escapeHTML(title)} from wishlist">
                <span aria-hidden="true">Remove</span>
              </button>
            </div>
          </article>
        `;
      })
      .join('');
  };
  const openDrawer = (trigger) => {
    if (!drawer) return;
    if (drawer.classList.contains('active')) return;
    window.ushoreCloseUtilityDrawers?.(drawer);
    renderDrawer();
    drawer.classList.remove('ushore-drawer-closing');
    drawer.classList.add('animate');
    window.requestAnimationFrame(() => {
      drawer.classList.add('active');
    });
    drawer.setAttribute('aria-hidden', 'false');
    drawer.activeElement = trigger;
    window.ushoreLockPage?.();
    window.setTimeout(() => drawer.querySelector('.drawer__inner')?.focus({ preventScroll: true }), 40);
  };
  const update = () => {
    const count = read().length;
    const savedUrls = new Set(read().map((item) => itemUrl(item)));
    document.querySelectorAll('.header__icon--wishlist').forEach((icon) => {
      icon.dataset.count = String(count);
      const bubble = icon.querySelector('.wishlist-count-bubble');
      if (bubble) bubble.textContent = String(count);
    });
    document.querySelectorAll('.ushore-card-wishlist[data-wishlist-placeholder]').forEach((button) => {
      const card = button.closest('.card-wrapper, .product, .card') || document;
      const link = normalizeUrl(button.dataset.productUrl || card?.querySelector('a[href*="/products/"]')?.getAttribute('href') || '');
      const isActive = savedUrls.has(link);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.setAttribute('aria-label', `${isActive ? 'Remove' : 'Add'} ${button.dataset.productTitle || 'item'} ${isActive ? 'from' : 'to'} wishlist`);
      if (button.classList.contains('ushore-product-wishlist-inline')) {
        const labelNode = Array.from(button.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (labelNode) labelNode.textContent = isActive ? ' Wishlisted' : ' Add to wishlist';
      }
    });
  };

  drawer?.addEventListener('click', (event) => {
    if (event.target.closest('[data-ushore-drawer-close]')) closeDrawer();
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      const url = normalizeUrl(remove.dataset.url);
      write(read().filter((item) => itemUrl(item) !== url));
      renderDrawer();
      update();
      return;
    }
    const add = event.target.closest('[data-wishlist-add]');
    if (add) {
      const variantId = add.dataset.variantId;
      if (!variantId) return;
      const cart = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(add);
      }
      add.disabled = true;
      add.classList.add('is-loading');
      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || 'Unable to add item');
          if (cart) {
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          } else {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist', cartData: response, variantId });
          }
          add.classList.remove('is-loading');
          add.classList.add('is-added');
          const removeUrl = add.closest('.ushore-wishlist-drawer__item')?.querySelector('[data-wishlist-remove]')?.dataset.url;
          if (removeUrl) write(read().filter((item) => itemUrl(item) !== removeUrl));
          renderDrawer();
          update();
        })
        .catch(() => {
          add.disabled = false;
          add.classList.remove('is-loading');
        });
    }
  });
  drawer?.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') closeDrawer();
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-wishlist-placeholder]');
    if (!trigger) return;
    if (trigger.hasAttribute('data-wishlist-page-link')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const card = trigger.closest('.card-wrapper, .product, .card') || document;
    const productForm = trigger.closest('product-form') || document.querySelector('product-form');
    const link = normalizeUrl(trigger.dataset.productUrl || card?.querySelector('a[href*="/products/"]')?.getAttribute('href') || window.location.pathname);
    const title = trigger.dataset.productTitle || card?.querySelector('.card__heading, .product__title h1, a[href*="/products/"]')?.textContent?.trim() || document.title;
    const image = trigger.dataset.productImage || card?.querySelector('img')?.currentSrc || card?.querySelector('img')?.src || '';
    const hoverImage = trigger.dataset.productHoverImage || card?.querySelectorAll('img')?.[1]?.currentSrc || card?.querySelectorAll('img')?.[1]?.src || '';
    const variantInput = productForm?.querySelector('input[name="id"], select[name="id"]');
    const variantId = trigger.dataset.variantId || variantInput?.value || '';
    const price = trigger.dataset.productPrice || '';
    const items = read();
    const exists = items.some((item) => itemUrl(item) === link);
    const next = exists ? items.filter((item) => itemUrl(item) !== link) : [...items, { url: link, title, image, hoverImage, variantId, price }];
    write(next);
    trigger.classList.toggle('is-active', !exists);
    trigger.setAttribute('aria-pressed', !exists ? 'true' : 'false');
    if (trigger.classList.contains('ushore-product-wishlist-inline')) {
      const labelNode = Array.from(trigger.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      if (labelNode) labelNode.textContent = !exists ? ' Wishlisted' : ' Add to wishlist';
    }
    renderDrawer();
    update();
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('[data-wishlist-placeholder][role="button"]');
    if (!trigger) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    trigger.click();
  });

  update();
})();

(() => {
  const productCache = new Map();

  const escapeHTML = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);

  const normalizeProductUrl = (url) => {
    try {
      const parsed = new URL(url || '', window.location.origin);
      const productMatch = parsed.pathname.match(/\/products\/[^/?#]+/);
      return productMatch ? productMatch[0] : parsed.pathname;
    } catch {
      return String(url || '').split('?')[0].split('#')[0];
    }
  };

  const productJsonUrl = (url) => `${normalizeProductUrl(url)}.js`;

  const fetchProduct = async (url) => {
    const key = normalizeProductUrl(url);
    if (productCache.has(key)) return productCache.get(key);
    const response = await fetch(productJsonUrl(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error('Unable to load product options');
    const product = await response.json();
    productCache.set(key, product);
    return product;
  };

  const productFromTrigger = async (trigger) => {
    if (trigger.dataset.productJson) {
      try {
        const product = JSON.parse(trigger.dataset.productJson);
        productCache.set(normalizeProductUrl(trigger.dataset.productUrl), product);
        return product;
      } catch {
        return fetchProduct(trigger.dataset.productUrl);
      }
    }
    return fetchProduct(trigger.dataset.productUrl);
  };

  const optionNames = (product) => {
    const names = Array.isArray(product.options)
      ? product.options.map((option) => (typeof option === 'string' ? option : option?.name)).filter(Boolean)
      : [];
    if (names.length === 1 && names[0].toLowerCase() === 'title') return [];
    const variant = product.variants?.[0];
    if (!names.length && variant?.option1) names.push('Size');
    if (!names.length) names.push('Size');
    return names.slice(0, 3);
  };

  const optionValues = (product, optionIndex) => {
    const option = product.options?.[optionIndex];
    if (option && typeof option !== 'string' && Array.isArray(option.values)) return option.values;
    const key = `option${optionIndex + 1}`;
    return [...new Set((product.variants || []).map((variant) => variant[key]).filter(Boolean))];
  };

  const variantOptions = (variant, optionCount) => {
    if (Array.isArray(variant.options) && variant.options.length) return variant.options.slice(0, optionCount);
    return [variant.option1, variant.option2, variant.option3].slice(0, optionCount).filter(Boolean);
  };

  const findVariant = (product, selected) => {
    const count = optionNames(product).length;
    return (product.variants || []).find((variant) => {
      const options = variantOptions(variant, count);
      return selected.every((value, index) => options[index] === value);
    });
  };

  const addVariantToCart = (variantId, trigger, sheet) => {
    const cart = document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(trigger);
    }

    const submit = sheet?.querySelector('[data-ushore-quick-add-submit]') || trigger;
    const error = sheet?.querySelector('[data-ushore-quick-add-error]');
    submit.setAttribute('aria-busy', 'true');
    submit.classList.add('is-loading');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    const routeConfig = window.routes || (typeof routes !== 'undefined' ? routes : {});
    const requestConfig = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/javascript' } };
    requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete requestConfig.headers['Content-Type'];
    requestConfig.body = formData;

    fetch(routeConfig.cart_add_url || '/cart/add', requestConfig)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Could not add this piece.');
        if (cart) {
          cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ushore-quick-add', cartData: response, variantId });
          } else {
            window.location.href = routeConfig.cart_url || '/cart';
          }
        }
        submit.removeAttribute('aria-busy');
        submit.classList.remove('is-loading');
        submit.textContent = 'Added to cart';
        submit.classList.add('is-added');
        sheet?.classList.add('is-added');
        trigger.classList.add('is-added');
        window.setTimeout(() => {
          sheet?.remove();
          trigger.classList.remove('is-added');
        }, 700);
      })
      .catch((errorObject) => {
        submit.removeAttribute('aria-busy');
        submit.classList.remove('is-loading');
        if (error) {
          error.textContent = errorObject?.message || 'Could not add this piece. Please try again.';
          error.removeAttribute('hidden');
        }
      });
  };

  const renderSheet = (product, trigger) => {
    document.querySelector('.ushore-quick-add-sheet')?.remove();

    const names = optionNames(product);
    const groups = names.map((name, index) => ({
      name,
      values: optionValues(product, index),
    })).filter((group) => group.values.length);

    const selected = groups.map((group) => (group.values.length === 1 ? group.values[0] : ''));
    const sheet = document.createElement('div');
    sheet.className = 'ushore-quick-add-sheet';
    sheet.innerHTML = `
      <div class="ushore-quick-add-sheet__panel" role="dialog" aria-label="Quick add ${escapeHTML(product.title)}">
        <div class="ushore-quick-add-sheet__groups">
          ${groups.map((group, groupIndex) => `
            <fieldset class="ushore-quick-add-sheet__group" data-ushore-quick-add-group="${groupIndex}">
              <legend>${escapeHTML(group.name)}</legend>
              <div class="ushore-quick-add-sheet__options">
                ${group.values.map((value) => `
                  <button
                    type="button"
                    class="${group.values.length === 1 ? 'is-selected' : ''}"
                    data-ushore-quick-add-option="${groupIndex}"
                    data-value="${escapeHTML(value)}"
                    aria-pressed="${group.values.length === 1 ? 'true' : 'false'}"
                  >${escapeHTML(value)}</button>
                `).join('')}
              </div>
            </fieldset>
          `).join('')}
        </div>
        <p class="ushore-quick-add-sheet__error" data-ushore-quick-add-error hidden></p>
        <button type="button" class="ushore-quick-add-sheet__submit" data-ushore-quick-add-submit disabled>Add to cart</button>
      </div>
    `;

    const valueCanAdd = (groupIndex, value) => (product.variants || []).some((variant) => {
      if (variant.available === false) return false;
      const options = variantOptions(variant, names.length);
      return options.every((optionValue, index) => {
        if (index === groupIndex) return optionValue === value;
        return !selected[index] || optionValue === selected[index];
      });
    });

    const syncOptions = () => {
      sheet.querySelectorAll('[data-ushore-quick-add-option]').forEach((button) => {
        const index = Number(button.dataset.ushoreQuickAddOption);
        const value = button.dataset.value;
        const isSelected = selected[index] === value;
        const isAvailable = valueCanAdd(index, value);
        button.classList.toggle('is-selected', isSelected);
        button.classList.toggle('is-unavailable', !isAvailable);
        button.disabled = !isAvailable;
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    };

    const syncSubmit = () => {
      const variant = selected.every(Boolean) ? findVariant(product, selected) : null;
      const submit = sheet.querySelector('[data-ushore-quick-add-submit]');
      submit.disabled = !variant || variant.available === false;
      if (!selected.every(Boolean)) {
        submit.textContent = groups.length > 1 ? 'Select options' : 'Select a size';
      } else {
        submit.textContent = variant && variant.available === false ? 'Sold out' : 'Add to cart';
      }
      submit.dataset.variantId = variant?.id || '';
    };

    const positionSheet = () => {
      const panel = sheet.querySelector('.ushore-quick-add-sheet__panel');
      if (!panel) return;
      const rect = trigger.getBoundingClientRect();
      const card = trigger.closest('.product-card-wrapper, .ushore-edge-products__card, .ushore-wishlist-page__item');
      const cardRect = card?.getBoundingClientRect();
      const cardWidth = cardRect?.width || rect.width || 320;
      const width = Math.min(340, Math.max(230, cardWidth), window.innerWidth - 24);
      panel.style.width = `${width}px`;
      let left = rect.right - width;
      left = Math.max(12, Math.min(left, window.innerWidth - width - 12));
      let top = rect.bottom + 8;
      const height = panel.offsetHeight;
      if (top + height > window.innerHeight - 12) top = rect.top - height - 8;
      top = Math.max(12, Math.min(top, window.innerHeight - height - 12));
      panel.style.left = `${left}px`;
      panel.style.top = `${top}px`;
    };

    const closeSheet = () => {
      window.removeEventListener('resize', positionSheet);
      window.removeEventListener('scroll', positionSheet, true);
      document.removeEventListener('click', closeOnOutside);
      sheet.remove();
    };

    const closeOnOutside = (event) => {
      if (sheet.contains(event.target) || trigger.contains(event.target)) return;
      closeSheet();
    };

    sheet.addEventListener('click', (event) => {
      const option = event.target.closest('[data-ushore-quick-add-option]');
      if (option) {
        if (option.disabled) return;
        const index = Number(option.dataset.ushoreQuickAddOption);
        selected[index] = option.dataset.value;
        sheet.querySelector('[data-ushore-quick-add-error]')?.setAttribute('hidden', '');
        syncOptions();
        syncSubmit();
        positionSheet();
        return;
      }

      const submit = event.target.closest('[data-ushore-quick-add-submit]');
      if (submit && submit.dataset.variantId) addVariantToCart(submit.dataset.variantId, trigger, sheet);
    });

    document.body.appendChild(sheet);
    window.requestAnimationFrame(() => {
      syncOptions();
      syncSubmit();
      positionSheet();
      sheet.classList.add('is-open');
      window.setTimeout(() => document.addEventListener('click', closeOnOutside), 0);
    });
    window.addEventListener('resize', positionSheet);
    window.addEventListener('scroll', positionSheet, true);
    syncSubmit();
  };

  const openQuickAdd = async (trigger) => {
    const productUrl = trigger.dataset.productUrl;
    if (!productUrl) return;
    trigger.classList.add('is-loading');
    try {
      const product = await productFromTrigger(trigger);
      renderSheet(product, trigger);
    } catch {
      trigger.classList.add('is-error');
      window.setTimeout(() => trigger.classList.remove('is-error'), 1200);
    } finally {
      trigger.classList.remove('is-loading');
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ushore-quick-add-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openQuickAdd(trigger);
  }, true);

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('[data-ushore-quick-add-trigger]');
    if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openQuickAdd(trigger);
  }, true);
})();

(() => {
  const root = document.querySelector('[data-wishlist-page-items]');
  if (!root) return;
  const countNode = document.querySelector('[data-wishlist-page-count]');

  const key = 'ushore:wishlist';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; }
  };
  const write = (items) => localStorage.setItem(key, JSON.stringify(items));
  const normalizeUrl = (url) => {
    try {
      const parsed = new URL(url || '', window.location.origin);
      const productMatch = parsed.pathname.match(/\/products\/[^/?#]+/);
      if (productMatch) return `${productMatch[0]}${parsed.search}`;
      return `${parsed.pathname}${parsed.search}`;
    } catch {
      return String(url || '').split('#')[0];
    }
  };
  const itemUrl = (item) => normalizeUrl(typeof item === 'string' ? item : item.url);
  const itemTitle = (item) => typeof item === 'string' ? 'Saved item' : item.title;
  const formatPrice = (price) => {
    if (price === null || price === undefined || price === '') return '';
    const cents = Number(price || 0);
    if (Number.isNaN(cents)) return '';
    return `RS. ${(cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };
  const escapeHTML = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);
  const enrichItems = async (items) => {
    const enriched = await Promise.all(items.map(async (item) => {
      if (typeof item !== 'string' && item.image && item.title && item.variantId && item.price && 'hoverImage' in item && Array.isArray(item.variants)) return item;
      const url = itemUrl(item);
      try {
        const response = await fetch(`${url.split('?')[0]}.js`);
        if (!response.ok) return item;
        const product = await response.json();
        return {
          url,
          title: product.title || itemTitle(item),
          image: product.featured_image || (typeof item === 'string' ? '' : item.image),
          hoverImage: product.images?.[1] || '',
          variantId: product.variants?.find((variant) => variant.available)?.id || product.variants?.[0]?.id || (typeof item === 'string' ? '' : item.variantId),
          price: product.price || product.variants?.[0]?.price || '',
          variants: product.variants || [],
        };
      } catch {
        return item;
      }
    }));
    if (JSON.stringify(enriched) !== JSON.stringify(items)) write(enriched);
    return enriched;
  };

  const openCart = (trigger, response, variantId) => {
    const cart = document.querySelector('cart-drawer');
    if (cart) {
      cart.classList.remove('is-empty');
      cart.renderContents(response);
      return;
    }
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist-page', cartData: response, variantId });
  };

  const addVariantToCart = (variantId, trigger) => {
    const cart = document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(trigger);
    }
    trigger.disabled = true;
    trigger.classList.add('is-loading');
    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || 'Unable to add item');
        trigger.classList.remove('is-loading');
        trigger.classList.add('is-added');
        openCart(trigger, response, variantId);
      })
      .catch(() => {
        trigger.disabled = false;
        trigger.classList.remove('is-loading');
      });
  };

  const openSizeSheet = (item, trigger) => {
    const variants = Array.isArray(item.variants) ? item.variants.filter((variant) => variant.available !== false) : [];
    if (variants.length <= 1) {
      addVariantToCart(item.variantId, trigger);
      return;
    }

    document.querySelector('.ushore-wishlist-size-sheet')?.remove();
    const sheet = document.createElement('div');
    sheet.className = 'ushore-wishlist-size-sheet';
    sheet.innerHTML = `
      <div class="ushore-wishlist-size-sheet__panel" role="dialog" aria-modal="true" aria-label="Choose size">
        <button type="button" class="ushore-wishlist-size-sheet__close" aria-label="Close">×</button>
        <p>Choose size</p>
        <h2>${escapeHTML(item.title || 'Select your size')}</h2>
        <div class="ushore-wishlist-size-sheet__options">
          ${variants.map((variant) => {
            const label = variant.option1 || variant.public_title || variant.title;
            return `<button type="button" data-wishlist-size-variant="${escapeHTML(variant.id)}">${escapeHTML(label)}</button>`;
          }).join('')}
        </div>
      </div>
    `;
    document.body.appendChild(sheet);
    window.requestAnimationFrame(() => sheet.classList.add('is-open'));
    sheet.addEventListener('click', (event) => {
      if (event.target === sheet || event.target.closest('.ushore-wishlist-size-sheet__close')) {
        sheet.remove();
        return;
      }
      const option = event.target.closest('[data-wishlist-size-variant]');
      if (!option) return;
      const variantId = option.dataset.wishlistSizeVariant;
      sheet.remove();
      addVariantToCart(variantId, trigger);
    });
  };

  const render = async () => {
    const items = await enrichItems(read());
    if (countNode) countNode.textContent = `${items.length} ${items.length === 1 ? 'item' : 'items'}`;
    document.querySelectorAll('.header__icon--wishlist').forEach((icon) => {
      icon.dataset.count = String(items.length);
      const bubble = icon.querySelector('.wishlist-count-bubble');
      if (bubble) bubble.textContent = String(items.length);
    });

    if (!items.length) {
      root.innerHTML = '<p class="ushore-wishlist-page__empty">Your wishlist is empty.</p>';
      return;
    }

    root.innerHTML = items.map((item) => {
      const url = itemUrl(item);
      const title = itemTitle(item);
      const displayTitle = title.toLocaleUpperCase('en-IN');
      const image = typeof item === 'string' ? '' : item.image;
      const hoverImage = typeof item === 'string' ? '' : item.hoverImage;
      const price = typeof item === 'string' ? '' : formatPrice(item.price);
      const variantId = typeof item === 'string' ? '' : item.variantId;
      return `
        <article class="ushore-wishlist-page__item">
          <a class="ushore-wishlist-page__media" href="${escapeHTML(url)}">
            ${image ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(title)}" loading="lazy">` : '<span></span>'}
            ${hoverImage ? `<img class="ushore-wishlist-page__image-secondary" src="${escapeHTML(hoverImage)}" alt="" loading="lazy">` : ''}
          </a>
          <button type="button" class="ushore-wishlist-page__heart is-active" data-wishlist-page-remove data-url="${escapeHTML(url)}" aria-label="Remove ${escapeHTML(title)} from wishlist">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 32 32">
              <path d="M16 26.1 7.55 17.65c-3-3-2.78-7.55.55-9.58 2.83-1.72 5.88-.74 7.9 2.34 2.02-3.08 5.07-4.06 7.9-2.34 3.33 2.03 3.55 6.58.55 9.58L16 26.1Z"/>
            </svg>
          </button>
          <div class="ushore-wishlist-page__details">
            <div>
              <a href="${escapeHTML(url)}">${escapeHTML(displayTitle)}</a>
              ${price ? `<span>${escapeHTML(price)}</span>` : ''}
            </div>
            <button type="button" class="ushore-card-quick-add ushore-card-quick-add--wishlist-page" data-ushore-quick-add-trigger data-product-url="${escapeHTML(url)}" data-product-title="${escapeHTML(title)}" data-variant-id="${escapeHTML(variantId)}" aria-label="Quick add ${escapeHTML(title)}">
              <span class="ushore-card-quick-add__icon" aria-hidden="true">
                <svg fill="none" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"/></svg>
              </span>
              <span class="ushore-card-quick-add__text">Quick add</span>
            </button>
          </div>
        </article>
      `;
    }).join('');
  };

  root.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-wishlist-page-remove]');
    if (remove) {
      write(read().filter((item) => itemUrl(item) !== normalizeUrl(remove.dataset.url)));
      render();
      return;
    }

    const add = event.target.closest('[data-wishlist-page-add]');
    if (!add) return;
    const url = normalizeUrl(add.dataset.url);
    const item = read().find((savedItem) => itemUrl(savedItem) === url);
    if (!item) return;
    openSizeSheet(item, add);
  });

  render();
})();

(() => {
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  const hydrateSecondaryImage = (card) => {
    if (!hoverQuery.matches || !card) return;
    const template = card.querySelector('[data-ushore-card-secondary-template]');
    const media = template?.closest('.media');
    if (!template || !media) return;
    media.appendChild(template.content.cloneNode(true));
    template.remove();
  };

  const handleIntent = (event) => {
    hydrateSecondaryImage(event.target.closest('.product-card-wrapper, .card-wrapper'));
  };

  document.addEventListener('pointerover', handleIntent, { passive: true });
  document.addEventListener('focusin', handleIntent);
})();

(() => {
  let controller;

  const setLoading = (container, select, isLoading) => {
    container.classList.toggle('is-loading', isLoading);
    select.disabled = isLoading;
  };

  const renderSortedCollection = async (form, select) => {
    const container = document.getElementById('ProductGridContainer');
    const grid = document.getElementById('product-grid');
    if (!container || !grid) {
      form.submit();
      return;
    }

    const sectionId = grid.dataset.id;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);

    const sectionUrl = new URL(url);
    if (sectionId) sectionUrl.searchParams.set('section_id', sectionId);

    if (controller) controller.abort();
    controller = new AbortController();
    setLoading(container, select, true);

    try {
      const response = await fetch(sectionUrl.toString(), {
        signal: controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Unable to sort collection');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextContainer = doc.getElementById('ProductGridContainer');
      if (!nextContainer) throw new Error('Missing sorted collection markup');

      container.innerHTML = nextContainer.innerHTML;
      window.history.replaceState({}, '', url.toString());
      window.ushoreRefreshMobileCollectionSort?.();
    } catch (error) {
      if (error.name === 'AbortError') return;
      form.submit();
    } finally {
      setLoading(container, select, false);
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#UshoreCollectionSortForm, .ushore-collection-sort__form');
    if (!form) return;
    event.preventDefault();
    const select = form.querySelector('#UshoreSortBy, .ushore-collection-sort__select');
    if (!select) return;
    renderSortedCollection(form, select);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('#UshoreSortBy, .ushore-collection-sort__select')) return;
    event.target.form?.requestSubmit();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ushore-sort-value]');
    if (!button) return;

    const form = button.closest('#UshoreCollectionSortForm, .ushore-collection-sort__form');
    const select = form?.querySelector('#UshoreSortBy, .ushore-collection-sort__select');
    if (!form || !select) return;

    select.value = button.dataset.ushoreSortValue;
    button.closest('.ushore-collection-sort__menu')?.removeAttribute('open');
    form.requestSubmit();
  });
})();
